/* ============================================================
   rakk-stories.js — RAKK.FR
   Bulles "stories" + lecteur vidéo modal (vidéo Shopify, YouTube, Vimeo)
   - Délégation d'événements : survit aux re-rendus de l'éditeur de thème
   - Idempotent : peut être chargé plusieurs fois sans double liaison
   ============================================================ */
(function () {
  'use strict';

  if (window.__rakkStories) { window.__rakkStories.init(); return; }

  var doc = document;
  var html = doc.documentElement;
  var STORE_KEY = 'rkst:viewed';
  var VIEWED_TTL = 7 * 24 * 3600 * 1000; // 7 jours
  var HOLD_MS = 220;                     // appui long => pause
  var SWIPE_PX = 60;                     // seuil de swipe

  var M = null; // références DOM du modal (créé au premier clic)
  var S = {     // état
    root: null, items: [], i: 0, open: false, mode: null,
    video: null, raf: 0, muted: false, autoNext: true,
    pushed: false, trigger: null, scrollY: 0, bodyCss: '', segs: []
  };

  /* ---------- Icônes ---------- */
  var ICON = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    on: '<svg class="rkst-btn__on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12"/></svg>',
    off: '<svg class="rkst-btn__off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M17 9.5l4 5M21 9.5l-4 5"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'
  };

  /* ---------- Stockage "déjà vu" (avec expiration) ---------- */
  function hash(str) {
    var h = 0, i;
    for (i = 0; i < str.length; i++) { h = ((h << 5) - h + str.charCodeAt(i)) | 0; }
    return (h >>> 0).toString(36);
  }
  function keyOf(el) {
    return (el.getAttribute('data-id') || '') + ':' + hash(el.getAttribute('data-mp4') || el.getAttribute('data-ext') || '');
  }
  function readViewed() {
    try {
      var o = JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
      return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
    } catch (e) { return {}; }
  }
  function writeViewed(o) { try { localStorage.setItem(STORE_KEY, JSON.stringify(o)); } catch (e) {} }
  function markViewed(el) {
    if (S.root.getAttribute('data-mark-viewed') !== 'true') return;
    var o = readViewed(), now = Date.now(), k;
    for (k in o) { if (now - o[k] > VIEWED_TTL) delete o[k]; }
    o[keyOf(el)] = now;
    writeViewed(o);
    el.classList.add('is-viewed');
  }
  function applyViewed(root) {
    if (root.getAttribute('data-mark-viewed') !== 'true') return;
    var o = readViewed(), now = Date.now(), items = root.querySelectorAll('[data-rkst-open]'), i, t;
    for (i = 0; i < items.length; i++) {
      t = o[keyOf(items[i])];
      if (t && now - t < VIEWED_TTL) items[i].classList.add('is-viewed');
    }
  }

  /* ---------- Piste : drag à la souris (le tactile scrolle nativement) ---------- */
  function enableDrag(track) {
    if (!track) return;
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); track.scrollLeft = startLeft - dx; }
    });
    function up() { down = false; setTimeout(function () { track.classList.remove('is-dragging'); }, 0); }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointerleave', up);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  /* ---------- Modal : construction (une seule fois) ---------- */
  function build(root) {
    var t = function (k, d) { return root.getAttribute('data-t-' + k) || d; };
    var el = doc.createElement('div');
    el.className = 'rkst-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', t('dialog', 'Stories'));
    el.setAttribute('aria-hidden', 'true');
    el.tabIndex = -1;
    el.innerHTML =
      '<div class="rkst-backdrop"></div>' +
      '<div class="rkst-stage">' +
        '<button type="button" class="rkst-btn rkst-nav rkst-nav--prev" aria-label="' + t('prev', 'Précédent') + '">' + ICON.prev + '</button>' +
        '<div class="rkst-card">' +
          '<div class="rkst-media"><video class="rkst-video"></video></div>' +
          '<div class="rkst-zones">' +
            '<div class="rkst-zone rkst-zone--l"></div>' +
            '<div class="rkst-zone rkst-zone--c"></div>' +
            '<div class="rkst-zone rkst-zone--r"></div>' +
          '</div>' +
          '<div class="rkst-spinner"></div>' +
          '<div class="rkst-pause">' + ICON.play + '</div>' +
          '<div class="rkst-error">' + t('error', 'Vidéo indisponible') + '</div>' +
          '<div class="rkst-top">' +
            '<div class="rkst-progress"></div>' +
            '<div class="rkst-head">' +
              '<img class="rkst-avatar" alt="" hidden>' +
              '<span class="rkst-title"></span>' +
              '<button type="button" class="rkst-btn rkst-mute" aria-label="' + t('mute', 'Couper le son') + '">' + ICON.on + ICON.off + '</button>' +
              '<button type="button" class="rkst-btn rkst-close" aria-label="' + t('close', 'Fermer') + '">' + ICON.close + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="rkst-btn rkst-nav rkst-nav--next" aria-label="' + t('next', 'Suivant') + '">' + ICON.next + '</button>' +
      '</div>';
    doc.body.appendChild(el);

    var q = function (s) { return el.querySelector(s); };
    M = {
      el: el, stage: q('.rkst-stage'), backdrop: q('.rkst-backdrop'), card: q('.rkst-card'),
      media: q('.rkst-media'), video: q('.rkst-video'), zones: q('.rkst-zones'),
      progress: q('.rkst-progress'), avatar: q('.rkst-avatar'), title: q('.rkst-title'),
      mute: q('.rkst-mute'), close: q('.rkst-close'), prev: q('.rkst-nav--prev'), next: q('.rkst-nav--next'),
      labels: { mute: t('mute', 'Couper le son'), unmute: t('unmute', 'Activer le son') }
    };
    S.video = M.video;
    bindVideo(S.video);

    M.close.addEventListener('click', function () { close(); });
    M.mute.addEventListener('click', function () { setMuted(!S.muted); });
    M.prev.addEventListener('click', function () { go(S.i - 1); });
    M.next.addEventListener('click', function () { go(S.i + 1); });
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target === M.backdrop || e.target === M.stage) close();
    });
    bindGestures();
  }

  /* ---------- Vidéo ---------- */
  function bindVideo(v) {
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.preload = 'auto';
    v.controls = false;
    v.disablePictureInPicture = true;
    v.addEventListener('waiting', function () { M.card.classList.add('is-loading'); });
    v.addEventListener('loadstart', function () { M.card.classList.add('is-loading'); });
    v.addEventListener('playing', function () {
      M.card.classList.remove('is-loading', 'is-paused', 'is-error');
      startRaf();
    });
    v.addEventListener('play', function () { M.card.classList.remove('is-paused'); });
    v.addEventListener('ended', function () {
      setSeg(S.i, 1);
      if (S.autoNext) go(S.i + 1);
    });
    v.addEventListener('error', function () {
      if (!v.getAttribute('src') || !v.error) return; // ignore les erreurs dues au nettoyage volontaire
      M.card.classList.remove('is-loading');
      M.card.classList.add('is-error');
    });
  }

  function setSeg(i, p) {
    var seg = S.segs[i];
    if (seg) seg.firstChild.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')';
  }
  function startRaf() {
    if (S.raf) return;
    (function tick() {
      S.raf = 0;
      var v = S.video;
      if (!S.open || S.mode !== 'file' || !v) return;
      if (v.duration > 0) setSeg(S.i, v.currentTime / v.duration);
      if (!v.paused && !v.ended) S.raf = requestAnimationFrame(tick);
    })();
  }

  function setMuted(m) {
    S.muted = !!m;
    if (S.video) S.video.muted = S.muted;
    M.mute.classList.toggle('is-muted', S.muted);
    M.mute.setAttribute('aria-label', S.muted ? M.labels.unmute : M.labels.mute);
  }

  function togglePause() {
    var v = S.video;
    if (S.mode !== 'file' || !v) return;
    if (v.ended) { v.currentTime = 0; safePlay(v); return; }
    if (v.paused) { safePlay(v); } else { v.pause(); M.card.classList.add('is-paused'); }
  }
  function holdPause(on) {
    var v = S.video;
    if (S.mode !== 'file' || !v || M.card.classList.contains('is-paused')) return;
    if (on) v.pause(); else safePlay(v);
  }
  function safePlay(v) {
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        // Lecture avec son refusée par le navigateur : on retente en muet
        if (!v.muted) {
          setMuted(true);
          var p2 = v.play();
          if (p2 && p2.catch) p2.catch(function () { M.card.classList.add('is-paused'); });
        } else {
          M.card.classList.add('is-paused');
        }
      });
    }
  }

  function externalSrc(url) {
    var m;
    url = url || '';
    m = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
    if (m) {
      return 'https://www.youtube-nocookie.com/embed/' + m[1] +
        '?autoplay=1&playsinline=1&rel=0&modestbranding=1&mute=' + (S.muted ? 1 : 0);
    }
    m = url.match(/vimeo\.com\/(?:.*\/)?(\d+)(?:\/(\w+))?/);
    if (m) {
      return 'https://player.vimeo.com/video/' + m[1] +
        '?autoplay=1&playsinline=1&title=0&byline=0&portrait=0' +
        (S.muted ? '&muted=1' : '') + (m[2] ? '&h=' + m[2] : '');
    }
    return null;
  }

  function stopMedia() {
    var old = M.media.querySelector('.rkst-frame');
    if (old) old.parentNode.removeChild(old);
    var v = S.video;
    if (v) {
      v.pause();
      if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); }
    }
    if (S.raf) { cancelAnimationFrame(S.raf); S.raf = 0; }
    M.card.classList.remove('is-loading', 'is-paused', 'is-error', 'is-file', 'is-external');
    S.mode = null;
  }

  /* ---------- Navigation ---------- */
  function go(i) {
    if (i >= S.items.length) { close(); return; }
    if (i < 0) i = 0;
    S.i = i;
    var it = S.items[i], k;

    stopMedia();
    for (k = 0; k < S.segs.length; k++) setSeg(k, k < i ? 1 : 0);

    M.title.textContent = it.getAttribute('data-label') || '';
    var av = it.getAttribute('data-avatar');
    if (av) { M.avatar.src = av; M.avatar.hidden = false; } else { M.avatar.hidden = true; }
    M.prev.hidden = (i === 0);
    M.next.hidden = (i === S.items.length - 1);
    markViewed(it);

    var mp4 = it.getAttribute('data-mp4'), ext = it.getAttribute('data-ext');
    if (mp4) {
      S.mode = 'file';
      M.card.classList.add('is-file', 'is-loading');
      M.mute.hidden = false;
      var v = S.video;
      v.muted = S.muted;
      v.poster = it.getAttribute('data-poster') || '';
      v.src = mp4;
      safePlay(v);
    } else {
      var src = externalSrc(ext);
      S.mode = 'external';
      M.card.classList.add('is-external');
      M.mute.hidden = true;
      setSeg(i, 1);
      if (src) {
        var f = doc.createElement('iframe');
        f.className = 'rkst-frame';
        f.src = src;
        f.title = it.getAttribute('data-label') || 'Vidéo';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        M.media.appendChild(f);
      } else {
        M.card.classList.add('is-error');
      }
    }
  }

  /* ---------- Ouverture / fermeture ---------- */
  function lockScroll() {
    S.scrollY = window.pageYOffset || html.scrollTop || 0;
    var sbw = window.innerWidth - html.clientWidth, b = doc.body;
    S.bodyCss = b.style.cssText;
    b.style.position = 'fixed';
    b.style.top = '-' + S.scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    if (sbw > 0) b.style.paddingRight = sbw + 'px';
  }
  function unlockScroll() {
    doc.body.style.cssText = S.bodyCss;
    try { window.scrollTo({ top: S.scrollY, left: 0, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, S.scrollY); }
  }

  function open(root, idx, trigger) {
    if (!M) build(root);
    var d = function (k) { return root.getAttribute('data-' + k); };

    S.root = root;
    S.trigger = trigger;
    S.items = [].slice.call(root.querySelectorAll('[data-rkst-open]'));
    S.autoNext = d('autonext') === 'true';

    M.el.style.setProperty('--rkst-ratio', d('ratio') || '.5625');
    M.el.style.setProperty('--rkst-maxw', (d('maxw') || 400) + 'px');
    M.el.style.setProperty('--rkst-radius', (d('radius') || 16) + 'px');
    M.el.style.setProperty('--rkst-overlay', d('overlay') || 'rgba(0,0,0,.8)');
    M.el.style.setProperty('--rkst-fit', d('fit') === 'contain' ? 'contain' : 'cover');
    M.el.classList.toggle('no-progress', d('progress') === 'false');

    // segments de progression
    M.progress.innerHTML = '';
    S.segs = [];
    for (var k = 0; k < S.items.length; k++) {
      var seg = doc.createElement('span');
      seg.className = 'rkst-seg';
      seg.innerHTML = '<i></i>';
      M.progress.appendChild(seg);
      S.segs.push(seg);
    }

    lockScroll();
    html.classList.add('rkst-open');
    M.el.classList.add('is-open');
    M.el.setAttribute('aria-hidden', 'false');
    S.open = true;
    setMuted(d('start-muted') === 'true');

    try { history.pushState({ rkst: 1 }, ''); S.pushed = true; } catch (e) { S.pushed = false; }

    go(idx);
    M.el.focus({ preventScroll: true }); // le dialog reçoit le focus (pas de halo sur un bouton)
  }

  function close(fromPop) {
    if (!S.open) return;
    S.open = false;
    stopMedia();
    M.el.classList.remove('is-open');
    M.el.setAttribute('aria-hidden', 'true');
    html.classList.remove('rkst-open');
    unlockScroll();
    if (S.pushed) {
      S.pushed = false;
      if (!fromPop) { try { history.back(); } catch (e) {} }
    }
    if (S.trigger && doc.contains(S.trigger)) { try { S.trigger.focus({ preventScroll: true }); } catch (e) {} }
    S.trigger = null;
  }

  /* ---------- Gestes : tap / appui long / swipe ---------- */
  function bindGestures() {
    var Z = M.zones, g = null;

    function zoneOf(x) {
      var r = M.card.getBoundingClientRect(), f = (x - r.left) / (r.width || 1);
      return f < 0.3 ? 'l' : (f > 0.7 ? 'r' : 'c');
    }
    Z.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      g = { x: e.clientX, y: e.clientY, held: false, zone: zoneOf(e.clientX) };
      g.timer = setTimeout(function () { if (g) { g.held = true; holdPause(true); } }, HOLD_MS);
      try { Z.setPointerCapture(e.pointerId); } catch (_) {}
    });
    Z.addEventListener('pointermove', function (e) {
      if (!g) return;
      if (Math.abs(e.clientX - g.x) > 10 || Math.abs(e.clientY - g.y) > 10) clearTimeout(g.timer);
    });
    function finish(e, cancelled) {
      if (!g) return;
      var G = g; g = null;
      clearTimeout(G.timer);
      if (G.held) { holdPause(false); return; }
      if (cancelled) return;
      var dx = e.clientX - G.x, dy = e.clientY - G.y, ax = Math.abs(dx), ay = Math.abs(dy);
      if (ay > SWIPE_PX && dy > 0 && ay > ax) { close(); return; }        // swipe bas => fermer
      if (ax > SWIPE_PX && ax > ay) { go(S.i + (dx < 0 ? 1 : -1)); return; } // swipe horizontal
      if (ax > 10 || ay > 10) return;
      if (G.zone === 'l') go(S.i - 1);
      else if (G.zone === 'r') go(S.i + 1);
      else togglePause();
    }
    Z.addEventListener('pointerup', function (e) { finish(e, false); });
    Z.addEventListener('pointercancel', function (e) { finish(e, true); });
    Z.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  /* ---------- Événements globaux ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-rkst-open]');
    if (!t) return;
    var root = t.closest('[data-rkst]');
    if (!root) return;
    e.preventDefault();
    var items = root.querySelectorAll('[data-rkst-open]');
    open(root, [].indexOf.call(items, t), t);
  });

  doc.addEventListener('keydown', function (e) {
    if (!S.open) return;
    var k = e.key;
    if (k === 'Escape') { e.preventDefault(); close(); }
    else if (k === 'ArrowRight') { e.preventDefault(); go(S.i + 1); }
    else if (k === 'ArrowLeft') { e.preventDefault(); go(S.i - 1); }
    else if (k === ' ' && !(e.target.closest && e.target.closest('button'))) { e.preventDefault(); togglePause(); }
    else if (k === 'Tab') {
      var f = [].slice.call(M.el.querySelectorAll('button')).filter(function (b) {
        return !b.hidden && b.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = doc.activeElement;
      if (!M.el.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === M.el)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Bouton "retour" du téléphone => ferme le lecteur
  window.addEventListener('popstate', function () { if (S.open) close(true); });

  // Onglet masqué => pause ; retour => reprise
  doc.addEventListener('visibilitychange', function () {
    if (!S.open || S.mode !== 'file' || !S.video) return;
    if (doc.hidden) S.video.pause();
    else if (!M.card.classList.contains('is-paused')) safePlay(S.video);
  });

  /* ---------- Init (bulles) ---------- */
  function init() {
    var roots = doc.querySelectorAll('[data-rkst]'), i, r;
    for (i = 0; i < roots.length; i++) {
      r = roots[i];
      if (r.__rkstReady) continue;
      r.__rkstReady = true;
      applyViewed(r);
      enableDrag(r.querySelector('.rkst__track'));
    }
  }
  window.__rakkStories = { init: init };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();

  // Éditeur de thème Shopify
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('rkst__item') && el.scrollIntoView) {
      el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  });
})();
